export default "/images/user.svg?780a52a3688dd2fd0230fe4949982dd5";